import svgConnect from "../../../../assets/imgs/socials/connects/google.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/google.svg";

import MyImage from "../../../myImage"

const MyIconGoogle = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'google icon'} sx={sx} />

export default MyIconGoogle;
